import * as React from "react"
import * as _ from "lodash"
import { IPatientAllergy } from "@curefit/ehr-common";
import {default as AppUtils, LOADING_STATE} from "../../utils/AppUtils"
import EditViewCard, {EditViewDisplayMode} from "../../components/common/EditViewCard"
import AppLoader from "../../components/utils/AppLoader"
import {PatientAllergyViewProps} from "../../components/patient/view/PatientAllergyView"
import {PatientAllergyEditorProps} from "../../components/patient/edit/PatientAllergyEditor"
import ModelFactory from "../../models/ModelFactory"
import {SourceConstants} from "../../utils/AppConstants";
import IEditedBy from "../../models/IEditedBy";
import {ITypeFormQuestionnaire} from "../../models/ITypeFormQuestionnaire";
import ErrorContainer from "./../ErrorContainer";
import IDoctorProfile from "../../models/IDoctorProfile";

/**
 * Created by abhinav on 28/01/18.
 */

export interface AllergyEditViewContProps {
    appointmentId?: number;
    patientId: number,
    patientAllergies: IPatientAllergy[],
    fetchPatientAllergies?: (patientId: number) => any,
    savePatientAllergies?: (patientId: number, patientAllergies: IPatientAllergy[]) => any,
    displayMode?: EditViewDisplayMode,
    editedBy?: IEditedBy,
    onInvalidItem?: (section: string) => void,
    questionnaire?: ITypeFormQuestionnaire[];
    typeFormMapping?: any;
    doctorProfile: IDoctorProfile[],
}

export interface AllergyEditViewContState {
    updatedAllergies: {item: IPatientAllergy}[],
    isPatientAllergyDataLoaded: LOADING_STATE,
    error: string,
    errorDetails: string
}

class AllergyEditViewCont extends React.Component<AllergyEditViewContProps, AllergyEditViewContState> {

    constructor(props: AllergyEditViewContProps) {
        super(props)
        this.state = this.getStateFromProps(props)
    }

    componentWillReceiveProps(props: AllergyEditViewContProps) {
        this.setState(this.getStateFromProps(props))
    }

    getUpdatedAllergiesFromProps = (props: AllergyEditViewContProps): {item: IPatientAllergy}[] => {
        let currUpdatedAllergies: {item: IPatientAllergy}[] = []
        _.map(props.patientAllergies, function(patientAllergy){
            let clonePatientAllergy = Object.assign({}, patientAllergy)
            currUpdatedAllergies.push({item: clonePatientAllergy})
        })
        return currUpdatedAllergies
    }

    getStateFromProps = (props: AllergyEditViewContProps) => {
        let currState: AllergyEditViewContState = {
            updatedAllergies: [],
            isPatientAllergyDataLoaded: LOADING_STATE.NOT_INITIALIZED,
            error: "",
            errorDetails: ""
        }
        if ( _.isNull(props.patientAllergies) ) {
            props.fetchPatientAllergies(this.props.patientId)
            currState.isPatientAllergyDataLoaded = LOADING_STATE.LOADING
        } else {
            currState.updatedAllergies = []
            _.map(props.patientAllergies, function(patientAllergy){
                let clonePatientAllergy = Object.assign({}, patientAllergy)
                currState.updatedAllergies.push({item: clonePatientAllergy})
            })
            currState.isPatientAllergyDataLoaded = LOADING_STATE.LOADED
        }
        return currState
    }

    getAllergyEditViewTemplateProps = () => {
        let patientAllergyViewProps: PatientAllergyViewProps = {
            allergies: this.props.patientAllergies,
            questionnaire: this.props.questionnaire,
            questionIdList: this.typeFormQuestionIdList()
        }
        let patientAllergyEditorProps: PatientAllergyEditorProps = {
            updatedAllergies: this.state.updatedAllergies,
            updateAllergies: this.updatePatientAllergy,
            questionnaire: this.props.questionnaire,
            questionIdList: this.typeFormQuestionIdList()
        }
        return {"view": patientAllergyViewProps, "edit": patientAllergyEditorProps}
    }

    updatePatientAllergy = (updatedAllergies: {item: IPatientAllergy}[]) => {
        this.setState({updatedAllergies: updatedAllergies})
    }

    savePatientAllergies = () => {
        let myInstance = this
        let saveAllergyList = this.getSaveObject();
        // if (saveAllergyList.length > 0) {
        if (this.isFormDirty()) {
            this.setState({
                error: "Cannot save Allergies",
                errorDetails: "Please fill in all the mandatory fields before proceeding"
            })
        } else {
            this.setState({isPatientAllergyDataLoaded: LOADING_STATE.NOT_INITIALIZED})
            this.props.savePatientAllergies(this.props.patientId, saveAllergyList).then(function(){
                myInstance.setState({isPatientAllergyDataLoaded: LOADING_STATE.LOADED})
            })
        }
        // }
    }

    getSaveObject = (): IPatientAllergy[] => {
        let patientId = this.props.patientId;
        let appointmentId = this.props.appointmentId;
        let editedBy = this.props.editedBy;
        let saveAllergyList: IPatientAllergy[] = []
        _.map(this.state.updatedAllergies, function(updateAllergyItem: {item: IPatientAllergy}){
            if (!ModelFactory.isAllergyEmpty(updateAllergyItem.item)) {
                let allergyItem = AppUtils.sanitizeRequestItemBeforeSave(updateAllergyItem.item);
                allergyItem.source = SourceConstants.DOCSASPP;
                if (editedBy !== undefined) {
                    allergyItem.lastEditedPersonId = parseInt(editedBy.id);
                    allergyItem.personType = editedBy.role.toLowerCase();
                    allergyItem.patientId = patientId;
                    allergyItem.appointmentId = appointmentId;
                    allergyItem.isDeleted = false;
                }
                saveAllergyList.push(allergyItem)
            }
        })
        return saveAllergyList;
    }

    isFormDirty = (): boolean => {
        let status = false;
        let erronousRows: number[] = [];
        _.map(this.state.updatedAllergies, function(updateAllergyItem: {item: IPatientAllergy}, index: number){
            if (!ModelFactory.isAllergyEmpty(updateAllergyItem.item) && !ModelFactory.isValidAllergy(updateAllergyItem.item)) {
                status = true;
                erronousRows.push(index + 1);
                return false;
            }
        })
        return status;
    }

    dirtyFormText = (): string => {
        let erronousRows: number[] = [];
        _.map(this.state.updatedAllergies, function(updateAllergyItem: {item: IPatientAllergy}, index: number){
            if (!ModelFactory.isValidAllergy(updateAllergyItem.item)) {
                erronousRows.push(index + 1);
                return false;
            }
        })
        let errorText = `Missing allergy name in row/(s) ${erronousRows.join(", ")}`;
        return errorText;
    }

    cancelActionHandler = () => {
        this.setState({updatedAllergies: this.getUpdatedAllergiesFromProps(this.props)})
    }

    typeFormQuestionIdList = (): string[] => {
        let questionList = [];
        if (!_.isEmpty(this.props.typeFormMapping)) {
            questionList = this.props.typeFormMapping.filter((item: any) => item.group === "ALLERGIES");
            if (!_.isEmpty(questionList)) {
                questionList = questionList.map((item: any) => item.code);
            }
        }
        return questionList;
    }

    clearErrorMessage = () => {
        this.setState({
            error: "",
            errorDetails: ""
        })
    }

    render() {
        let isAllergyDataLoaded =  this.state.isPatientAllergyDataLoaded === LOADING_STATE.LOADED;
        let errorMessage = !_.isEmpty(this.state.error) ? this.state.error : null;
        let errorDetails = !_.isEmpty(this.state.errorDetails) ? this.state.errorDetails : "";
        return (
            <div className="allergy-editview-cont">
                {
                    !_.isNull(errorMessage) &&
                    <ErrorContainer errorText={errorMessage} errorDetails={errorDetails} errorCode={0} closeError={this.clearErrorMessage}/>
                }
                {
                    isAllergyDataLoaded &&
                    <EditViewCard cardTitleDisplay={"Allergy"} templateName={"allergy"}
                        templateProps={this.getAllergyEditViewTemplateProps()}
                        lastEditedEpoch={new Date().getTime()} saveActionHandler={this.savePatientAllergies}
                        cancelActionHandler={this.cancelActionHandler} displayMode={this.props.displayMode}
                    />
                }
                {
                    !isAllergyDataLoaded &&
                    <AppLoader/>
                }
            </div>
        )
    }
}

export default AllergyEditViewCont